import { render, staticRenderFns } from "./Sem.vue?vue&type=template&id=2ed381e3"
import script from "./Sem.vue?vue&type=script&lang=ts"
export * from "./Sem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports